const COLORS = {
  ERROR: '#da6767',
};

export default COLORS;
